import React from 'react'
import "../Footer/Footer.css";
import Logo from "../../Image/nav-logo.webp";
import { Link } from "react-router-dom";
function FooterBottom() {
  return (
    <div>
      <div className="Footer-bottom">
<img src={Logo} alt="" className="Footer-logo"/>
<div>
  <Link to="/" className='Link'><p>Home</p></Link>
  <Link to="/About" className="Link"><p>About Us</p></Link>
  <Link to="/Contact" className="Link"><p>Contact Us</p></Link>
  <Link to="/Careers" className="Link"><p>Job / Careers</p></Link>
</div>
<div>
  <Link to="/PrivacyPolicy" className='Link'><p>Privacy Policy</p></Link>
  <Link to="/TermsConditions" className="Link"><p>Terms & Conditions</p></Link>
  <Link to="/CookiePolicy" className='Link'><p>Cookie Policy</p></Link>
  <Link to="https://haisam10.github.io/freelancer/" target='_blank' className="Link"><p>Developer Team</p></Link>
</div>
<div>
  <Link to="https://www.facebook.com/S.te.Sotero" target='_blank' className="Link"><p>Facebook page</p></Link>
  <Link to="https://www.instagram.com/stesotero0" target='_blank' className="Link"><p>Instagram page</p></Link>
  <Link to="https://www.tiktok.com/@stesotero0" target='_blank' className="Link"><p>TikTok page</p></Link>
  <Link to="https://maps.app.goo.gl/2RxgD36pWu6CscLz8" target='_blank' className="Link"><p>Google map</p></Link>
</div>
<div>
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d532.0788883677819!2d90.3657648488416!3d23.85516405012449!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c10077d2e311%3A0x93c8095bd9574b2b!2zIuCmuCIg4Kak4KeHICLgprjgpqTgp4fgprDgp4siIOCmsOCnh-CmuOCnjeCmn-CngeCmsOCnh-CmqOCnjeCmnw!5e0!3m2!1sen!2sbd!4v1743674481826!5m2!1sen!2sbd" className='FooterMap'></iframe>
</div>
</div>
<div className="Mini-Footer">
  <p><hr /><br /></p>
          <p>Copyright © 2025  " স তে সতেরো " | All Rights Reserved</p>
          <p><br /></p>
      </div>
    </div>
  )
}

export default FooterBottom